import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useTravels() {
  const { visible, type, travelShowType } = useAppSelector((state) => state.travel);
  // const { dataForPost } = useAppSelector((state) => state.star);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "14f4fa9f-1963-4e25-b39d-2832af933db8",
    IncludeNonServiceBranches: false,
    Parameters: {
      "ff398aef-3fb4-47d4-b905-eb1a79f5ed67": [type],
      "ad600f20-d489-492a-93c7-1a7eec4a6ce3": date.created_after || "2020-06-03",
      "a6de16d1-09fd-4bef-951d-a6cae1f1eb15": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, type, travelShowType],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data.Rows, "nzgvdvnnfg");
        return res.data.Rows;
      });
    },
    enabled: visible && (travelShowType === 0 || travelShowType === 1),
  });

  return { data, isLoading, refetch, isFetching };
}
